$(document).ready(function () {
  var reviewRatingRateSpan = $('.review-rating__rate');

  if (reviewRatingRateSpan) {
    var blogArticleId = reviewRatingRateSpan.data('blog-article-id');
  }

  $('.label-star').on('click', function () {
    var url = $(this).data('url');

    $.ajax({
      url: url,
      method: 'GET',
      success: function (response) {
        if (response.ok) {
          console.log(response);
          $('.count-evaluation').text(response.countEvaluation);
          setCookie('blog-article-evaluation-' + blogArticleId, true, 365);
        } else {
          console.log(response);
        }
        reviewRatingRateSpan.removeClass('is-active');
        $('.review-rating__icon').attr('class', 'review-rating__icon');
      },
      error: function (response) {
        console.log(response);
      },
    });
  });
});
